// hooks/useIdlePrompt.js
import { useEffect, useState, useRef } from 'react';
import { getCookie, setCookie } from '../utilities/cookieUtils';
import { triggerRefreshTokenApi } from './utils';
 
const IDLE_THRESHOLD_MS = 60 * 60 * 1000; // 20 minutes
const CHECK_INTERVAL_MS = 30000; // 30 seconds
const COOKIE_NAME = 'LASTACT';
const COUNTDOWN_SECONDS = 15
 const LOGOUT_COOKIE="XUSRLGLK"
export const useIdlePrompt = ({ onContinue, onLogout }) => {
  const [showPrompt, setShowPrompt] = useState(false);
  const [countdown,setCountdown] = useState(COUNTDOWN_SECONDS)
  const countdownIntervalRef = useRef(null);
  const activityDetectedRef = useRef(false);
  const showPromptref = useRef(false);
  const clearIntervalRef = useRef(false)
  const REFRESH_COOKIE = 'REFRESH_SYNC_V1'; 
  const LOCAL_STORAGE_REFRESH_KEY = 'last_seen_refresh_sync_v1';

  useEffect(() => {
    const LOCAL_KEY = LOCAL_STORAGE_REFRESH_KEY;
    let lastSeen = null;
   
    const checkRefreshSync = () => {
      const cookieValue = getCookie(REFRESH_COOKIE);
      const currlocal =localStorage.getItem(LOCAL_KEY);
      if (cookieValue && cookieValue !== currlocal) {
        localStorage.setItem(LOCAL_KEY, cookieValue);
        lastSeen = cookieValue;
        triggerRefreshTokenApi();
      }
    };
   
    const interval = setInterval(checkRefreshSync, 2000);
   
    window.addEventListener('focus', checkRefreshSync);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        checkRefreshSync();
      }
    });
   
    // Run once on load (in case refresh was already triggered before mount)
    checkRefreshSync();
   
    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', checkRefreshSync);
      document.removeEventListener('visibilitychange', checkRefreshSync);
    };
  }, [triggerRefreshTokenApi]);

  const updateActivity = () => {
    setCookie(COOKIE_NAME, new Date().toISOString());
  };
 
  const checkIdleStatus = () => {
    const logoutCookie = getCookie(LOGOUT_COOKIE);
    if(logoutCookie==='true'){
        handleLogout();
        return
    }
    if(clearIntervalRef.current) {
        return;
    }
    const last = new Date(getCookie(COOKIE_NAME));
    const now = new Date();
    const diff = now - last;
    if (diff > IDLE_THRESHOLD_MS) {
      setTimeout(() => {
        const updated = new Date(getCookie(COOKIE_NAME));
        if (new Date() - updated > IDLE_THRESHOLD_MS && !showPromptref.current) {
          setShowPrompt(true);
          showPromptref.current = true
          setCountdown(COUNTDOWN_SECONDS);
          activityDetectedRef.current = false;
        }
      }, 200); // wait to avoid race condition with another tab updating
    }
  };
 
  useEffect(() => {
   
    updateActivity(); // Initial set
 
    const activityHandler = () => updateActivity();
 
    window.addEventListener('click', activityHandler);
    window.addEventListener('keydown', activityHandler);
    window.addEventListener('mousemove', activityHandler);
    window.addEventListener('scroll', activityHandler);
 
    window.addEventListener('focus', checkIdleStatus);
 
    const interval = setInterval(checkIdleStatus, CHECK_INTERVAL_MS);
 
    return () => {
      window.removeEventListener('click', activityHandler);
      window.removeEventListener('keydown', activityHandler);
      window.removeEventListener('mousemove', activityHandler);
      window.removeEventListener('scroll', activityHandler);
      window.removeEventListener('focus', checkIdleStatus);
      clearInterval(interval);
    };
  }, []);
  useEffect(() => {
    const handleVisibilityOrFocus = () => {
      const logoutCookie = getCookie(LOGOUT_COOKIE);
      if (logoutCookie === 'true') {
        handleLogout(); // Another tab already logged out
        return;
      }
   
      const lastActivity = new Date(getCookie(COOKIE_NAME)).getTime();
      const now = Date.now();
      const logoutDeadline = lastActivity + IDLE_THRESHOLD_MS + COUNTDOWN_SECONDS * 1000;
   
      if (now >= logoutDeadline) {
        handleLogout(); // Deadline passed, logout directly
      } else if (now >= lastActivity + IDLE_THRESHOLD_MS) {
        // Idle time passed, but not deadline — show prompt with countdown
        const secondsLeft = Math.ceil((logoutDeadline - now) / 1000);
        setCountdown(secondsLeft);
        setShowPrompt(true);
      }
    };
   
    window.addEventListener('focus', handleVisibilityOrFocus);
    document.addEventListener('visibilitychange', handleVisibilityOrFocus);
   
    return () => {
      window.removeEventListener('focus', handleVisibilityOrFocus);
      document.removeEventListener('visibilitychange', handleVisibilityOrFocus);
    };
  }, []);

 

  useEffect(() => {
    if (!showPrompt) return;
   
    const handleUserActivity = () => {
      if (!activityDetectedRef.current) {
        activityDetectedRef.current = true;
        handleContinue(); // reset timer and hide prompt
      }
    };
   
    window.addEventListener('click', handleUserActivity);
    window.addEventListener('keydown', handleUserActivity);
    window.addEventListener('mousemove', handleUserActivity);
   
    const interval = setInterval(() => {
      const lastActivity = new Date(getCookie(COOKIE_NAME)).getTime();
      const now = Date.now();
      const logoutDeadline = lastActivity + IDLE_THRESHOLD_MS + COUNTDOWN_SECONDS * 1000;
      const secondsLeft = Math.ceil((logoutDeadline - now) / 1000);
   
      if (secondsLeft <= 0) {
        clearInterval(interval);
        handleLogout();
      } else {
        setCountdown(secondsLeft);
      }
    }, 1000);
   
    return () => {
      clearInterval(interval);
      window.removeEventListener('click', handleUserActivity);
      window.removeEventListener('keydown', handleUserActivity);
      window.removeEventListener('mousemove', handleUserActivity);
    };
  }, [showPrompt]);
  
  const handleContinue = () => {
    updateActivity();
    setShowPrompt(false);
    showPromptref.current = false

    if (onContinue) onContinue();
  };
 
  const handleLogout = () => {
    showPromptref.current = false
    clearIntervalRef.current = true
    setCookie(LOGOUT_COOKIE,'true')
    setShowPrompt(false);
    if (onLogout) onLogout();
  };
 
  return {
    showPrompt,
    countdown,
    handleContinue,
    handleLogout,
  };
};
 